/* eslint-disable react/jsx-filename-extension */
import { useMutation, useQuery } from '@apollo/client';
import React, { useCallback } from 'react';

import {
  EventEmitter,
  getCurrentUserHook,
  getTranslatedText,
  useCurrentServicePortal
} from '@nile/components/src';

import {
  AccountClient,
  GET_PERSONALIZATION_BY_NAME,
  SAVE_PERSONALIZATION
} from '@nile/graphql/src';
import { ADD_TASK_VIEW } from '@nile/graphql/src/Mutation/task';
import { useIntl } from 'react-intl';
import { TaskViewModal } from './TaskViewModal';

export function CreateTaskView({ onClose, allViewsData }) {
  const [addTaskView] = useMutation(ADD_TASK_VIEW);

  const intl = useIntl();

  const user = getCurrentUserHook();
  const manageViewCategoryName = useCurrentServicePortal('workspace');

  const {
    data: personalizedData,
    loading: personalizationLoading,
    refetch: getPersonilizationByName
  } = useQuery(GET_PERSONALIZATION_BY_NAME, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      userId: user.userId,
      category: manageViewCategoryName,
      name: 'ManageViews'
    }
  });

  const [mutateSidebarPersonalization] = useMutation(SAVE_PERSONALIZATION, {
    client: AccountClient
  });

  const saveSidebarCustomisation = useCallback(
    (value) => {
      return mutateSidebarPersonalization({
        variables: {
          name: 'ManageViews',
          category: manageViewCategoryName,
          user: {
            firstName: user?.firstName,
            userId: user?.userId,
            email: user?.email,
            lastName: user?.lastName
          },
          value: JSON.stringify(value)
        }
      });
    },
    [user, mutateSidebarPersonalization]
  );

  return (
    <TaskViewModal
      isOpen
      title={getTranslatedText(intl, 'task.view.create.header')}
      actions={{
        back: onClose,
        primaryAction: (input) => {
          return addTaskView({ variables: { input } }).then((res) => {
            const id = res?.data?.addView?.id;
            return getPersonilizationByName()
              .then((personalizedResp) => {
                if (
                  !personalizedResp?.data?.getPersonalizationByCategoryAndName
                    ?.value ||
                  personalizedResp?.data?.getPersonalizationByCategoryAndName
                    ?.value === 'null'
                ) {
                  const dataToBeSaved = Object.entries(allViewsData)
                    .map(([key, value]) => {
                      return {
                        ...value,
                        section: key
                      };
                    }, [])
                    .reduce((acc, { section, heading, list, ...rest }) => {
                      const selectedViews = list.reduce(
                        (idList, { id, isChecked }) => {
                          if (isChecked) {
                            idList.push(id);
                          }
                          return idList;
                        },
                        []
                      );
                      acc[section] = {
                        ...rest,
                        list:
                          // Add the new task view id in personlization
                          section === 'task'
                            ? [id, ...selectedViews]
                            : selectedViews
                      };
                      return acc;
                    }, {});
                  return dataToBeSaved;
                }

                const leftNavPersonalization = JSON.parse(
                  personalizedResp.data.getPersonalizationByCategoryAndName
                    .value
                );

                leftNavPersonalization.task.list = [
                  id,
                  ...leftNavPersonalization.task.list
                ];
                return leftNavPersonalization;
              })
              .then(saveSidebarCustomisation)
              .then(() => {
                EventEmitter.dispatch('newTaskViewAdded');
                EventEmitter.dispatch('refreshTaskViewCount');
                return res;
              });
          });
        },
        savePersonalization: () => {}
      }}
    />
  );
}
